<div style="display: flex; flex-direction: column" class="wrapper">
  <bfx-nav-menu style="flex: 0 0 auto"></bfx-nav-menu>
  <bfx-app-alert-container
    style="display: flex; flex-direction: column; flex: 1 1 auto; overflow: hidden"
    (onChange)="handleAlertChange($event)"
  >
    <!--
    -->
    <golden-layout style="height: 100%; overflow: hidden"></golden-layout>
    <!-- <div>
    </div> -->
  </bfx-app-alert-container>
  <bfx-footer-bar style="flex: 0 0 auto"></bfx-footer-bar>
</div>
<div *ngIf="delayFadeIn" class="loader">Loading...</div>
